<template>
  <div class="bg">
    <el-radio-group v-model="currentType" @change="searcRank()" style="margin: 40px 0 0 0">
      <el-radio-button :label="info.school">校区榜单</el-radio-button>
      <el-radio-button label="nationwide">全国榜单</el-radio-button>
    </el-radio-group>
    <div style="margin-top: 30px">
      你的积分: {{info.rank}}
    </div>
    <div style="width: 100%; margin: 40px 0 0 0">
      <el-row>
        <el-col :span="2" :offset="3" class="rank-title-area">名次</el-col>
        <el-col :span="4" class="rank-title-area">姓名</el-col>
        <el-col :span="6" class="rank-title-area">学校</el-col>
        <el-col :span="3" class="rank-title-area">段位</el-col>
        <el-col :span="3" class="rank-title-area">积分</el-col>
      </el-row>
    </div>
    <div v-for="(item, i) in ranklist" :key="item.id" style="width: 100%; margin: 40px 0 0 0;overflow-y: auto">
      <el-row>
        <el-col :span="2" :offset="3" class="rank-info-area" :style="{backgroundColor: item.nickname==info.nickname?'#ffbe6a':'#FFFFFF'}">{{i+1}}</el-col>
        <el-col :span="4" class="rank-info-area" :style="{backgroundColor: item.nickname==info.nickname?'#ffbe6a':'#FFFFFF'}">{{item.nickname}}</el-col>
        <el-col :span="6" class="rank-info-area" :style="{backgroundColor: item.nickname==info.nickname?'#ffbe6a':'#FFFFFF'}">{{item.schoolName}}</el-col>
        <el-col :span="3" class="rank-info-area" :style="{backgroundColor: item.nickname==info.nickname?'#ffbe6a':'#FFFFFF'}">{{item.level}}</el-col>
        <el-col :span="3" class="rank-info-area" :style="{backgroundColor: item.nickname==info.nickname?'#ffbe6a':'#FFFFFF'}">{{item.score}}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return{
      baseApi: '/ranklist',
      currentType: 'nationwide',
      ranklist: [],
      rank: {
        0: '萌新原木',
        60: '勤奋青铜I',
        150: '勤奋青铜II',
        350: '好学白银I',
        550: '好学白银II',
        1050: '博学黄金I',
        1800: '博学黄金II',
        2750: '博学黄金III',
        4200: '智慧白金I',
        6200: '智慧白金II',
        8750: '智慧白金III',
        11000: '璀璨钻石I',
        14500: '璀璨钻石II',
        18000: '璀璨钻石III',
        21500: '学习大师I',
        25000: '学习大师II',
        30000: '最强王者',
      }
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  methods: {
    searcRank() {
      this.$fly.post(`${this.baseApi}/${this.currentType}`,{'id': this.info.id}).then((res)=>{
        for (let i = 0; i < res.length; i++) {
          if (res[i].score == 0) {
            res.splice(i,1)
            i--;
          } else {
            this.findLevel(res[i])
          }
        }
        this.ranklist = res
      })
    },
    findLevel(item) {
      let level;
      for(let k in this.rank){
        if(item.score>=k){
          level = this.rank[k]
        } else {
          item.level = level;
          return
        }
      }
    }
  },
  created() {
    this.searcRank()
  }
}
</script>

<style scoped>
.bg{
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}
.rank-info-area{
  margin-right: 3px;
  padding: 10px;
  font: 1.5em sans-serif;
}
.rank-title-area{
  margin-right: 3px;
  padding: 10px;
  font: 1.9em sans-serif;
}
@media screen and (max-width: 1400px) { 
  .rank-info-area{
  margin-right: 2px;
  padding: 5px;
  font: 1em sans-serif;
}
}
</style>
